import { useAuth } from "@/features/auth/hooks/useAuth";
import { useBrowserSession } from "@/shared/hooks/useBrowserSession";

export type { WarningLevel } from "@/shared/hooks/useBrowserSession";

export const useActivityChannel = () => {
  const { user, isAuthenticated, logout } = useAuth();
  return useBrowserSession(isAuthenticated ? user?.employee?.id : undefined, logout);
};
